import { useEffect } from "react";

/** Mount-only external synchronization without repeating effect boilerplate. */
export function useMountEffect(effect: () => void | (() => void)): void {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, []);
}
